import React from "react";
import swal from "sweetalert";
import { usePost } from "seed/api";
import { useQuery } from "seed/gql";
import l from "components/util/l";
import View from "components/presentation/sections/settings/roles/RoleFormView.view";

function RoleFormCreate({
  flowId,
  onlyAdminRoles,
  reqRoles,
  onClose
}) {

  // The route, not the generic mutation: it writes the permissions a new role starts with.
  const [callCreate] = usePost("/flows/create_role", {
    onCompleted: () => {
      onClose();
      reqRoles.refetch();
    },
    onError: (error) => {
      swal("Error", l("No fue posible crear el rol%PA063"), "error");
      console.error("Error al crear el rol", error);
    },
  });

  const reqLicenses = useQuery(`{ 
    licenses { 
      name 
      } 
    }`, `flow.id=${flowId}`, { orderBy: "id" }
  );

  const onSubmit = (values) => {

    const { name, requiredLicense } = values;
    if (!name) {
      swal("Error", l("El nombre es requerido%PA064"), "error");
      return;
    }

    callCreate({
      flow_id: flowId,
      name: name,
      is_admin: onlyAdminRoles || false,
      required_license_id: requiredLicense ? Number(requiredLicense) : null,
    });

  }

  const { licenses = [] } = reqLicenses.data;

  return <View
    role={{ name: "", requiredLicense: "" }}
    licenses={licenses}
    onSubmit={onSubmit}
  />;

}

export default RoleFormCreate;